import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import BrandThemeApplier from "@/components/BrandThemeApplier";
import FeatureGate from "@/components/FeatureGate";
import AppLayout from "@/components/layout/AppLayout";
import Landing from "@/pages/Landing";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import AdminPasswordPolicy from "@/pages/admin/AdminPasswordPolicy";
import AdminDataWipe from "@/pages/admin/AdminDataWipe";
import AdminAuthEvents from "@/pages/admin/AdminAuthEvents";
import Login from "@/pages/Login";
import RestoreCompany from "@/pages/RestoreCompany";
import Signup from "@/pages/Signup";
import Dashboard from "@/pages/Dashboard";
import BankReconAutoMatch from "@/pages/BankReconAutoMatch";
import QCDashboard from "@/pages/QCDashboard";
import StoresQueue from "@/pages/StoresQueue";
import GateInward from "@/pages/GateInward";
import BOMIssue from "@/pages/BOMIssue";
import BOMReceive from "@/pages/BOMReceive";
import BOMRevAuditor from "@/pages/reports/BOMRevAuditor";
import PaymentSheet from "@/pages/PaymentSheet";
import UserGuide from "@/pages/UserGuide";
import GuideShare from "@/pages/GuideShare";
import AIWalkthroughOverlay from "@/components/AIWalkthroughOverlay";
import PrepaidWizard from "@/pages/PrepaidWizard";
import Accounts from "@/pages/Accounts";
import Vouchers from "@/pages/Vouchers";
import Sales from "@/pages/Sales";
import Purchases from "@/pages/Purchases";
import PartiesPage from "@/pages/Parties";
import Inventory from "@/pages/Inventory";
import FixedAssets from "@/pages/FixedAssets";
import Reports from "@/pages/Reports";
// Iter-215 · FinancialStatements page merged into Reports > Financial Statements tab.
import FemaRealisation from "@/pages/reports/FemaRealisation";
import Rule37Reversal from "@/pages/reports/Rule37Reversal";
import AS11Restatement from "@/pages/reports/AS11Restatement";
import WorkingCapitalSimulator from "@/pages/reports/WorkingCapitalSimulator";
import FixedAssetSimulator from "@/pages/reports/FixedAssetSimulator";
import RcmRegister from "@/pages/reports/RcmRegister";
import GstReports from "@/pages/reports/GstReports";
import CompanyGstins from "@/pages/CompanyGstins";
import Compliance from "@/pages/Compliance";
import ComplianceReturnPage from "@/pages/compliance/ComplianceReturnPage";
import Approvals from "@/pages/Approvals";
import ApprovalsInbox from "@/pages/approvals/ApprovalsInbox";
import GroupFilingDashboard from "@/pages/reports/GroupFilingDashboard";
import ESignDocuments from "@/pages/ESignDocuments";
import IneligibleItcRegister from "@/pages/reports/IneligibleItcRegister";
import Gstr1Preview from "@/pages/gstr/Gstr1Preview";
import ImsDashboard from "@/pages/gstr/ImsDashboard";
import Gstr3bForm from "@/pages/gstr/Gstr3bForm";
import PendingJvReview from "@/pages/vouchers/PendingJvReview";
import AuditPage from "@/pages/AuditPage";
import Templates from "@/pages/Templates";
import Settings from "@/pages/Settings";
import HelpCenter from "@/pages/HelpCenter";
import Distribution from "@/pages/Distribution";
import AIPage from "@/pages/AIPage";
import Payments from "@/pages/Payments";
import Reconcile from "@/pages/Reconcile";
import BankRules from "@/pages/BankRules";
import ImportPage from "@/pages/ImportPage";
import Subscription from "@/pages/Subscription";
import VanSales from "@/pages/VanSales";
import TDSPage from "@/pages/TDSPage";
import BOM from "@/pages/BOM";
import Workflow from "@/pages/Workflow";
import Budgets from "@/pages/Budgets";
import Recurring from "@/pages/Recurring";
import MSMEReport from "@/pages/MSMEReport";
import GatePass from "@/pages/GatePass";
import MfgMasters from "@/pages/MfgMasters";
import Production from "@/pages/Production";
import ShopFloor from "@/pages/ShopFloor";
import MRP from "@/pages/MRP";
import Maintenance from "@/pages/Maintenance";
import Quality from "@/pages/Quality";
import Procurement from "@/pages/Procurement";import Costing from "@/pages/Costing";
import NPD from "@/pages/NPD";
import BRSReview from "@/pages/BRSReview";
import Andon from "@/pages/Andon";
import Dealership from "@/pages/Dealership";
import TallyMigrator from "@/pages/TallyMigrator";
import Registers from "@/pages/Registers";
import ComplianceCalendar from "@/pages/ComplianceCalendar";
import Segments from "@/pages/Segments";
import SegmentMIS from "@/pages/SegmentMIS";
import AdvanceTax from "@/pages/AdvanceTax";
import MISPack from "@/pages/MISPack";
import Consolidation from "@/pages/Consolidation";
import O2CCompliance from "@/pages/O2CCompliance";
import NotesRegister from "@/pages/NotesRegister";
import StatementOfAccount from "@/pages/StatementOfAccount";
import JobWork from "@/pages/JobWork";
import ComplianceHub from "@/pages/ComplianceHub";
import TaxAudit from "@/pages/TaxAudit";
import CorporateCompliance from "@/pages/CorporateCompliance";
import PurchaseReturn from "@/pages/PurchaseReturn";
import MGT7Wizard from "@/pages/MGT7Wizard";
import Form8Wizard from "@/pages/Form8Wizard";
import AOC4Wizard from "@/pages/AOC4Wizard";
import DPT3Wizard from "@/pages/DPT3Wizard";
import GenericMCAWizard from "@/pages/GenericMCAWizard";
import ITRAutoPrep from "@/pages/ITRAutoPrep";
import ZohoMigrator from "@/pages/ZohoMigrator";
import MigratorMapper from "@/pages/MigratorMapper";
import Tickets from "@/pages/Tickets";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminLayout from "@/pages/admin/AdminLayout";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import { AdminTenantsList, AdminTenantDetail } from "@/pages/admin/AdminTenants";
import AdminTickets from "@/pages/admin/AdminTickets";
import AdminSecurity from "@/pages/admin/AdminSecurity";
import AdminBroadcasts from "@/pages/admin/AdminBroadcasts";
import AdminApprovals from "@/pages/admin/AdminApprovals";
import AdminBrochureDesigner from "@/pages/settings/BrochureDesigner";
import AppearanceSettings from "@/pages/settings/AppearanceSettings";
import AdminTeam from "@/pages/admin/AdminTeam";
import AdminEntities from "@/pages/admin/AdminEntities";
import AdminUsage from "@/pages/admin/UsagePanel";
import PortalFeaturesPanel from "@/pages/admin/PortalFeaturesPanel";
import BrandingPanel from "@/pages/admin/BrandingPanel";
import { AdminProvider } from "@/context/AdminContext";
import { SubscriptionProvider } from "@/context/SubscriptionContext";
import AgencyLayout from "@/pages/agency/AgencyLayout";
import AgencyDashboard from "@/pages/agency/AgencyDashboard";
import AgencyClients from "@/pages/agency/AgencyClients";

function Guard({ children }) {
  const { user, org, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center text-muted-foreground">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  // If user's active org is an Agency, they belong in the /agency panel — not /app.
  if (org?.is_agency) return <Navigate to="/agency/dashboard" replace />;
  return children;
}

function AgencyGuard({ children }) {
  const { user, org, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center text-muted-foreground">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (!org?.is_agency) return <Navigate to="/app/dashboard" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrandThemeApplier />
        <SubscriptionProvider>
          <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/restore" element={<RestoreCompany />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/guide-share/:orgId/:code" element={<GuideShare />} />
            <Route path="/app" element={<Guard><AppLayout /></Guard>}>
              <Route index element={<Navigate to="/app/dashboard" replace />} />
              <Route path="dashboard" element={<Dashboard />} />
              <Route path="bank/auto-match" element={<BankReconAutoMatch />} />
              <Route path="qc" element={<QCDashboard />} />
              <Route path="stores-queue" element={<StoresQueue />} />
              <Route path="gate-inward" element={<GateInward />} />
              <Route path="bom-issue" element={<BOMIssue />} />
              <Route path="bom-receive" element={<BOMReceive />} />
              <Route path="reports/bom-rev-audit" element={<BOMRevAuditor />} />
              <Route path="payment-sheet" element={<PaymentSheet />} />
              <Route path="prepaid" element={<PrepaidWizard />} />
              <Route path="user-guide" element={<UserGuide />} />
              <Route path="accounts" element={<Accounts />} />
              <Route path="vouchers" element={<Vouchers />} />
              <Route path="vouchers/pending-review" element={<PendingJvReview />} />
              <Route path="sales" element={<FeatureGate feature="sales"><Sales /></FeatureGate>} />
              <Route path="purchases" element={<FeatureGate feature="purchases"><Purchases /></FeatureGate>} />
              <Route path="customers" element={<FeatureGate feature="customers"><PartiesPage type="customer" /></FeatureGate>} />
              <Route path="vendors" element={<FeatureGate feature="vendors"><PartiesPage type="vendor" /></FeatureGate>} />
              <Route path="inventory" element={<Inventory />} />
              <Route path="assets" element={<FixedAssets />} />
              <Route path="reports" element={<Reports />} />
              {/* Iter-215 · legacy /financial-statements deep-links redirect to Reports (constitution-aware FS lives inside Reports > Financial Statements tab) */}
              <Route path="financial-statements" element={<Navigate to="/app/reports?tab=fs" replace />} />
              <Route path="reports/fema-realisation" element={<FemaRealisation />} />
              <Route path="reports/rule37-reversal" element={<Rule37Reversal />} />
              <Route path="reports/as11-restatement" element={<AS11Restatement />} />
              <Route path="reports/working-capital" element={<WorkingCapitalSimulator />} />
              <Route path="reports/fa-simulator" element={<FixedAssetSimulator />} />
              <Route path="reports/rcm-register" element={<RcmRegister />} />
              <Route path="reports/gst-reports" element={<GstReports />} />
              <Route path="settings/company-gstins" element={<CompanyGstins />} />
              <Route path="settings/appearance" element={<AppearanceSettings />} />
              <Route path="compliance" element={<Compliance />} />
              <Route path="compliance/gstr6"  element={<ComplianceReturnPage returnKey="gstr6" />} />
              <Route path="compliance/gstr6a" element={<ComplianceReturnPage returnKey="gstr6a" />} />
              <Route path="compliance/gstr9"  element={<ComplianceReturnPage returnKey="gstr9" />} />
              <Route path="compliance/gstr9c" element={<ComplianceReturnPage returnKey="gstr9c" />} />
              <Route path="compliance/itc-04" element={<ComplianceReturnPage returnKey="itc04" />} />
              <Route path="approvals" element={<Approvals />} />
              <Route path="approvals/inbox" element={<ApprovalsInbox />} />
              <Route path="reports/group-filing" element={<GroupFilingDashboard />} />
              <Route path="esign" element={<ESignDocuments />} />
              <Route path="reports/ineligible-itc" element={<IneligibleItcRegister />} />
              <Route path="gstr1" element={<Gstr1Preview />} />
              <Route path="ims" element={<ImsDashboard />} />
              <Route path="gstr3b" element={<Gstr3bForm />} />
              <Route path="audit" element={<AuditPage />} />
              <Route path="admin/portal-features" element={<PortalFeaturesPanel />} />
              <Route path="admin/branding" element={<BrandingPanel />} />
              <Route path="approvals" element={<Approvals />} />
              <Route path="templates" element={<Templates />} />
              <Route path="settings" element={<Settings />} />
              <Route path="help" element={<HelpCenter />} />
              <Route path="help/:slug" element={<HelpCenter />} />
              <Route path="distribution" element={<Distribution />} />
              <Route path="ai" element={<AIPage />} />
              <Route path="payments" element={<FeatureGate feature="payments"><Payments /></FeatureGate>} />
              <Route path="reconcile" element={<FeatureGate feature="reconcile"><Reconcile /></FeatureGate>} />
              <Route path="bank-rules" element={<BankRules />} />
              <Route path="import" element={<ImportPage />} />
              <Route path="subscription" element={<Subscription />} />
              <Route path="van-sales" element={<VanSales />} />
              <Route path="tds" element={<TDSPage />} />
              <Route path="bom" element={<BOM />} />
              <Route path="budgets" element={<Budgets />} />
              <Route path="recurring" element={<Recurring />} />
              <Route path="msme-report" element={<MSMEReport />} />
              <Route path="gate-pass" element={<FeatureGate feature="gate_pass_outward"><GatePass /></FeatureGate>} />
              <Route path="mfg-masters" element={<MfgMasters />} />
              <Route path="production" element={<Production />} />
              <Route path="mrp" element={<MRP />} />
              <Route path="maintenance" element={<Maintenance />} />
              <Route path="quality" element={<Quality />} />
              <Route path="procurement" element={<Procurement />} />
              <Route path="costing" element={<Costing />} />
              <Route path="npd" element={<NPD />} />
              <Route path="dealership" element={<FeatureGate feature="dealership"><Dealership /></FeatureGate>} />
              <Route path="tally-migrator" element={<TallyMigrator />} />
              <Route path="registers" element={<Registers />} />
              <Route path="compliance-calendar" element={<ComplianceCalendar />} />
              <Route path="segments" element={<Navigate to="/app/settings" replace />} />{/* Iter-210 · merged into Settings → Dimensions */}
              <Route path="mis" element={<SegmentMIS />} />
              <Route path="mis-pack" element={<MISPack />} />
              <Route path="consolidation" element={<Consolidation />} />
              <Route path="credit-notes" element={<FeatureGate feature="credit_notes"><NotesRegister kind="credit" /></FeatureGate>} />
              <Route path="debit-notes" element={<FeatureGate feature="debit_notes"><NotesRegister kind="debit" /></FeatureGate>} />
              <Route path="o2c-compliance" element={<O2CCompliance />} />
              <Route path="advance-tax" element={<AdvanceTax />} />
              <Route path="sales-workflow" element={<Workflow kind="sales" />} />
              <Route path="purchase-workflow" element={<Workflow kind="procurement" />} />
              <Route path="brs-review" element={<BRSReview />} />
              <Route path="statement-of-account" element={<StatementOfAccount />} />
              <Route path="job-work" element={<JobWork />} />
              <Route path="compliance" element={<ComplianceHub />} />
              <Route path="tax-audit" element={<TaxAudit />} />
              <Route path="corporate-compliance" element={<CorporateCompliance />} />
              <Route path="corporate-compliance/mgt-7" element={<MGT7Wizard />} />
              <Route path="corporate-compliance/form-8" element={<Form8Wizard />} />
              <Route path="corporate-compliance/aoc-4" element={<AOC4Wizard />} />
              <Route path="corporate-compliance/dpt-3" element={<DPT3Wizard />} />
              <Route path="corporate-compliance/:formCode" element={<GenericMCAWizard />} />
              <Route path="itr" element={<ITRAutoPrep />} />
              <Route path="zoho-migrator" element={<ZohoMigrator />} />
              <Route path="migrator-mapper" element={<MigratorMapper />} />
              <Route path="purchase-return" element={<PurchaseReturn />} />
              <Route path="tickets" element={<Tickets />} />
            </Route>
            {/* Platform Ops — Super-admin portal (Feb 2026) */}
            <Route path="/admin/login" element={<AdminProvider><AdminLogin /></AdminProvider>} />
            <Route path="/admin" element={<AdminProvider><AdminLayout /></AdminProvider>}>
              <Route index element={<AdminDashboard />} />
              <Route path="dashboard" element={<AdminDashboard />} />
              <Route path="entities" element={<AdminEntities />} />
              <Route path="usage" element={<AdminUsage />} />
              <Route path="tenants" element={<AdminTenantsList />} />
              <Route path="tenants/:id" element={<AdminTenantDetail />} />
              <Route path="approvals" element={<AdminApprovals />} />
              <Route path="team" element={<AdminTeam />} />
              <Route path="tickets" element={<AdminTickets />} />
              <Route path="security" element={<AdminSecurity />} />
              <Route path="broadcasts" element={<AdminBroadcasts />} />
              <Route path="password-policy" element={<AdminPasswordPolicy />} />
              <Route path="auth-events" element={<AdminAuthEvents />} />
              <Route path="data-wipe" element={<AdminDataWipe />} />
              <Route path="brochure" element={<AdminBrochureDesigner />} />
            </Route>
            {/* Agency Panel — CA firms / consultants running many client books (Feb 2026) */}
            <Route path="/agency" element={<AgencyGuard><AgencyLayout /></AgencyGuard>}>
              <Route index element={<Navigate to="/agency/dashboard" replace />} />
              <Route path="dashboard" element={<AgencyDashboard />} />
              <Route path="clients" element={<AgencyClients />} />
            </Route>
            {/* Kiosk shell — outside AppLayout */}
            <Route path="/shopfloor" element={<Guard><ShopFloor /></Guard>} />
            <Route path="/andon" element={<Guard><Andon /></Guard>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          {/* Iter-110 · AI walkthrough overlay is mounted globally — activates on ?walkthrough=<code> */}
          <AIWalkthroughOverlay />
          </BrowserRouter>
        </SubscriptionProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
